export const AppConfig = {
    pagination_size: 10,
    token_cap: 4000,
};
